import React from 'react';

export default function Privacy() {
  return (
    <div className="prose-page">
      <h1>Privacy Policy</h1>
      <p className="updated">Last updated: 25 September 2026</p>

      <p>
        The Pantry Life ("we", "our", "us") is committed to protecting your privacy. This
        Privacy Policy explains how our iOS apps — PokerTrainer, BlackjackTrainer,
        BridgeTrainer, and Where on Earth! — handle your information.
      </p>

      <h2>Information we do not collect</h2>
      <p>
        Our apps do not collect, transmit, or store any personal information. Specifically:
      </p>
      <ul>
        <li>No account creation or login is required.</li>
        <li>No analytics or telemetry SDKs are included in any app.</li>
        <li>No advertising identifiers (IDFA) are accessed or transmitted.</li>
        <li>No location data is requested or collected.</li>
        <li>No data is shared with any third party.</li>
      </ul>

      <h2>Data stored on your device</h2>
      <p>
        All app state — such as your training scores and session history — is stored
        locally on your device using iOS standard storage. This data never leaves your
        device and is removed when you uninstall the app.
      </p>

      <h2>Apple services</h2>
      <p>
        Our apps are distributed via the Apple App Store. Apple may collect usage
        information as part of their standard platform services. Please refer to Apple's
        privacy policy at{' '}
        <a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer">
          apple.com/legal/privacy
        </a>{' '}
        for details.
      </p>

      <h2>In-app purchases</h2>
      <p>
        Some apps offer optional in-app purchases managed entirely by Apple's StoreKit
        framework. The Pantry Life does not receive or store any payment card information.
      </p>

      <h2>Children</h2>
      <p>
        Our apps do not knowingly collect information from children under the age of 13. The
        apps contain no features designed for children and do not target children as an
        audience.
      </p>

      <h2>Changes to this policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Changes will be reflected by
        an updated date at the top of this page. Continued use of our apps after any change
        constitutes your acceptance of the updated policy.
      </p>

      <h2>Contact</h2>
      <p>
        If you have questions about this Privacy Policy, please contact us via our{' '}
        <a href="/support">support page</a>.
      </p>
    </div>
  );
}
